import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { trackRouter } from "vue-gtag-next";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: () => import("../pages/index.vue"),
    children: [
      {
        path: "places/:placeIdHash",
        name: "places",
        component: () => import("../pages/places/_placeIdHash/index.vue"),
      },
      {
        path: "maps/:latlng",
        name: "maps",
        component: () => import("../pages/maps/index.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// gtag
trackRouter(router);
export default router;
